//
//
//
//
//
//

import $ from 'jquery'
export default {
  props: ['title', 'subTitle', 'shareImg'],
  watch: {
    $route: 'fetch'
  },
  methods: {
    fetch() {
      let _this = this
      $(function() {
        var LINK = window.location.href

        $.ajax({
          url: 'https://wechatauth.aiyaopai.com/auth/jsapisignature',
          type: 'Get',
          async: false,
          dataType: 'jsonp',
          jsonp: 'callback', //值可变，名称随意，但一般设为callback就可以了
          jsonpCallback: 'gdd',
          success: function(data) {
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: data.AppId, // 必填，公众号的唯一标识
              timestamp: data.Timestamp, // 必填，生成签名的时间戳
              nonceStr: data.NonceString, // 必填，生成签名的随机串
              signature: data.Signature.toLowerCase(), // 必填，签名，见附录1
              jsApiList: [
                'checkJsApi',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo'
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })

            wx.ready(function() {
              // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
              wx.onMenuShareTimeline({
                title: _this.title, // 分享标题
                link: LINK, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: _this.shareImg, // 分享图标
                success: function() {
                  // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                  // 用户取消分享后执行的回调函数
                }
              })

              wx.onMenuShareAppMessage({
                title: _this.title, // 分享标题
                desc: _this.subTitle, // 分享描述
                link: LINK, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: _this.shareImg, // 分享图标
                type: '', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function() {
                  // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                  // 用户取消分享后执行的回调函数
                }
              })
            })
          }
        })
      })
    }
  },
  mounted() {
    this.fetch()
  }
}



// WEBPACK FOOTER //
// ./src/components/WechatShare/WechatShare.vue